'use strict';
'use es6';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Ajax = require('./utils/Ajax');

var _Ajax2 = _interopRequireDefault(_Ajax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RssListing = function () {
  function RssListing(options) {
    _classCallCheck(this, RssListing);

    this.id = options.id;
    this.show_detail = options.show_detail;
    this.show_date = options.show_date;
    this.show_author = options.show_author;
    this.attribution_text = options.attribution_text;
    this.item_title_tag = options.item_title_tag;
    this.publish_date_text = options.publish_date_text;
    this.include_featured_image = options.include_featured_image;

    this.handleResults = this.handleResults.bind(this);

    _Ajax2.default.get(options.rss_hcms_url, this.handleResults);
  }

  _createClass(RssListing, [{
    key: 'handleResults',
    value: function handleResults(data) {
      var _this = this;

      var rssFeed = document.querySelector('.hs-hash-' + this.id);
      if (rssFeed.querySelectorAll('.hs-rss-item').children) {
        return;
      }

      data.forEach(function (row) {
        var showAuthor = _this.show_author && row.author;
        var showDate = _this.show_date && row.date;
        var showFeaturedImage = _this.include_featured_image && row.featuredImage;
        var showDetail = _this.show_detail;

        var itemClass = showFeaturedImage ? ' hs-with-featured-image' : '';

        var attributionHtml = showAuthor ? _this.attribution_text + '<span class="hs-rss-author">' + row.author + '</span>' : '';

        var dateHtml = showDate ? '\n      <span class="hs-rss-posted-at"> ' + _this.publish_date_text + '</span>\n      <span class="hs-rss-date">' + row.published + '</span>\n      ' : '';

        var detailHtml = showDetail ? '\n      <div class="hs-rss-description">\n      <p>' + row.summary + '</p>\n      </div>\n      ' : '';

        var imageHtml = showFeaturedImage ? '\n      <div class="hs-rss-item-image-wrapper">\n      <img class="hs-rss-featured-image" src="' + row.featuredImage + '" alt="' + row.featuredImageAltText + '">\n      </div>\n      ' : '';

        var html = '\n          <div class="hs-rss-item ' + itemClass + '">\n          <div class="hs-rss-item-text">\n          <a class="hs-rss-title" href="' + row.link + '"><' + _this.item_title_tag + '>' + row.title + '</' + _this.item_title_tag + '></a>\n          <div class="hs-rss-byline">\n          ' + attributionHtml + dateHtml + '\n          </div>\n          ' + detailHtml + '\n          </div>\n          ' + imageHtml + '\n          </div>\n          ';

        rssFeed.insertAdjacentHTML('beforeend', html);
      });

      if (typeof hsRssFeedComplete === 'function') {
        window.hsRssFeedComplete(rssFeed);
      }
    }
  }]);

  return RssListing;
}();

window.hsPopulateRssFeed = function (options) {
  return new RssListing(options);
};


//////////////////
// WEBPACK FOOTER
// ./js/rss_listing_asset.js
// module id = 3
// module chunks = 1